module.exports = __webpack_public_path__ + "baa859ee970bccd46bf12b50802c431b.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/team/CarolinaMastretta.png
// module id = 388
// module chunks = 0